import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import {AdminApi} from "../Api/AdminApi";

const MediaDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [mediaPageData, setMediaPageData] = useState(null);
    const [resetFilter, setResetFilter] = useState(false)
    const [topic, setTopic] = useState('')

    useEffect(() => {
        if (resetFilter) {
            setTopic('')
        }
    }, [resetFilter])

    useEffect(() => {
        // AdminApi.User.getAdminPageMediaData({}, session.jwt).then(res => {
        //     setMediaPageData(res.data);
        // }).catch(error => {
        //     if (error.message?.includes( '404')) {
        //         setSessionCookie({})
        //         window.location.href = window.location.hostname
        //     }
        // })
    }, [session.jwt])

    return <div>
        <SideBar session={session} title={"Media"}>
            <div className={s.adminDashboard}>
                <main className={s.dataSection}>
                    <h3 className='heading'>Media</h3>
                </main>
            </div>
        </SideBar>
    </div>
}

export default (MediaDashboard);
